import { render, staticRenderFns } from "./ModalHistoricoLeituraLeitor.vue?vue&type=template&id=586cff0c"
import script from "./ModalHistoricoLeituraLeitor.vue?vue&type=script&lang=js"
export * from "./ModalHistoricoLeituraLeitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports